// @flow

import React from 'react'
import styled from 'styled-components'
import moment from 'moment'
import { Visibility } from 'semantic-ui-react'

import { spacing } from 'frontend_core/dist/styles/variables'

import Loading from 'components/atoms/Loading'
import StatusDate from 'components/atoms/StatusDate'
import FloatBottom from 'components/molecules/message/FloatBottom'
import MessageOutline from 'components/molecules/message/MessageOutline'
import MessageSelf from 'components/molecules/message/MessageSelf'
import MessageOpponent from 'components/molecules/message/MessageOpponent'
import MessageStatus from 'components/molecules/message/MessageStatus'
import SendImageSelf from 'components/molecules/message/SendImageSelf'
import SendImageOpponent from 'components/molecules/message/SendImageOpponent'
import SendFileSelf from 'components/molecules/message/SendFileSelf'
import SendFileOpponent from 'components/molecules/message/SendFileOpponent'
import MessageWithAttachmentSelf from 'components/molecules/message/MessageWithAttachmentSelf'
import MessageWithAttachmentOpponent from 'components/molecules/message/MessageWithAttachmentOpponent'
import { mediaMin } from 'frontend_core/dist/styles/media'

const DateWrapper = styled.div`
  text-align: center;
`
const Section = styled.div`
  margin-top: ${spacing.medium_2}px;
  ${mediaMin.phone`
    margin-top: ${spacing.medium_3}px;
  `};
`

const LoadingContainer = styled.div`
  padding: 0 ${spacing.medium}px;
  text-align: center;
`

type PropTypes = {
  reservationMessage: {
    show: boolean,
    reservationDate: moment | Date,
    date: string,
    time: string,
    purposeUse: string,
    utilityForm: string,
    numberOfPeople: string,
    applicationDetail: string,
  },
  isInquiry: boolean,
  messages: Array<{
    isSelf: boolean,
    isOpponent: boolean,
    systemMessage: string, // システムメッセージ
    selfMessage: string, // 自分のメッセージ
    opponentMessage: string, // 相手のメッセージ
    iconImage?: string, // メッセージのアイコン画像
    read: boolean, // 既読状態
    time: string,
    image?: {
      src: string,
      alt: string,
      thumbnailUrl: string,
      filename: string,
    },
    file?: {
      filename: string,
      fileUrl: string,
    },
    receivedAt: moment | Date,
    receivedDateText: string,
  }>,
  messageText: string,
  buttonsDisable: boolean,
  onReachedTop: Function,
  loading: boolean,
  onRefTopMessageBaloon: Function,
  handleChangeText: Function,
  onClickSend: Function,
  onClickFile: Function,
  onRefInputFile: Function,
  onChangeFile: Function,
}

export default (props: PropTypes) => {
  const { reservationMessage, messages, onReachedTop, loading } = props
  let lastReceiveDate = moment(reservationMessage.reservationDate)

  return (
    <div>
      <Visibility onTopVisible={onReachedTop} continuous />
      {loading && (
        <LoadingContainer>
          <Loading />
        </LoadingContainer>
      )}
      {/* 予約内容概要メッセージ部分 */}
      {reservationMessage.show && (
        <div>
          <DateWrapper>
            <StatusDate text={reservationMessage.date} />
          </DateWrapper>
          <Section>
            <MessageOutline
              time={reservationMessage.time}
              purposeUse={reservationMessage.purposeUse}
              utilityForm={reservationMessage.utilityForm}
              numberOfPeople={reservationMessage.numberOfPeople}
              applicationDetail={reservationMessage.applicationDetail}
              isInquiry={props.isInquiry}
            />
          </Section>
        </div>
      )}
      {/* メッセージ部分 */}
      {messages.map((message, i) => {
        let receiveDateSection = null
        if (
          moment(message.receivedAt).format('YYYYMMDD') !==
          moment(lastReceiveDate).format('YYYYMMDD')
        ) {
          lastReceiveDate = moment(message.receivedAt)
          // いままで出してたメッセージと日付が変わったので日付セクションを表示
          receiveDateSection = (
            <Section>
              <DateWrapper>
                <StatusDate text={message.receivedDateText} />
              </DateWrapper>
            </Section>
          )
        }

        let MessageBaloonComponent = () => <div />
        let contentProps = {}
        if (message.systemMessage) {
          MessageBaloonComponent = MessageStatus
          contentProps = Object.assign(contentProps, {
            statusText: message.systemMessage,
          })
        } else if (message.isSelf) {
          // 自分の吹き出しコンポーネント決定
          if (message.image && message.selfMessage) {
            MessageBaloonComponent = MessageWithAttachmentSelf
          } else if (message.file && message.selfMessage) {
            MessageBaloonComponent = MessageWithAttachmentSelf
          } else if (message.image) {
            MessageBaloonComponent = SendImageSelf
          } else if (message.file) {
            MessageBaloonComponent = SendFileSelf
          } else {
            MessageBaloonComponent = MessageSelf
          }
          contentProps = Object.assign(contentProps, {
            messageText: message.selfMessage,
          })
        } else if (message.isOpponent) {
          // 相手の吹き出しコンポーネント決定
          if (message.image && message.opponentMessage) {
            MessageBaloonComponent = MessageWithAttachmentOpponent
          } else if (message.file && message.opponentMessage) {
            MessageBaloonComponent = MessageWithAttachmentSelf
          } else if (message.image) {
            MessageBaloonComponent = SendImageOpponent
          } else if (message.file) {
            MessageBaloonComponent = SendFileOpponent
          } else {
            MessageBaloonComponent = MessageOpponent
          }
          contentProps = Object.assign(contentProps, {
            opponentImage: message.iconImage,
            messageText: message.opponentMessage,
          })
        }

        contentProps = Object.assign(contentProps, {
          read: message.read,
          time: message.time,
        })

        if (message.image) {
          const { image } = message
          contentProps = Object.assign(contentProps, {
            thumbnailUrl: image.thumbnailUrl,
            src: image.src,
            alt: image.alt,
            filename: image.filename,
          })
        } else if (message.file) {
          const { file } = message
          contentProps = Object.assign(contentProps, {
            filename: file.filename,
            fileUrl: file.fileUrl,
            thumbnailUrl: file.fileUrl,
            isAttachment: true,
          })
        }

        return (
          <div key={`message_from_section_${i}`}>
            {receiveDateSection}
            <Section innerRef={i === 0 ? props.onRefTopMessageBaloon : null}>
              <MessageBaloonComponent {...contentProps} />
            </Section>
          </div>
        )
      })}
      <FloatBottom
        onChangeText={props.handleChangeText}
        buttonsDisable={props.buttonsDisable}
        onClickSend={props.onClickSend}
        messageText={props.messageText}
        onClickFile={props.onClickFile}
        onRefInputFile={props.onRefInputFile}
        onChangeFile={props.onChangeFile}
      />
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/organisms/ReservationMessagesForm/index.jsx